import $ from 'jquery';
import 'bootstrap';
import Swiper from 'swiper/bundle';
import Cookies from 'js-cookie';
import gsap from "gsap";
import 'slick-carousel';
import 'slick-carousel';

import ScrollTrigger from "gsap/ScrollTrigger";
import all from 'gsap/all';

function animations() {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.matchMedia({
    // all
    "all": function () {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "100",
          end: "300",
          pin: false
        }
      });
      tl.to("nav", { backgroundColor: "#ffffff" })

      let locations = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "300",
          end: "400",
          pin: false
        }
      });
      locations.to(".quotation", { top: "74px" })

      let NavRow = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "300",
          end: "400",
          pin: false,
        }
      });
      NavRow.to("nav .row", { height: "74px" })

      let NavSub = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "300",
          end: "400",
          pin: false,
        }
      });
      NavSub.to(".sub-menu", { top: "70px" })

      let Branding = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "200",
          end: "400",
          pin: false
        }
      });
      Branding.to(".normal--branding", { opacity: "1", top: "-30px", transitionDuration: '0' })

      let BrandingColors = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "200",
          end: "400",
          pin: false,
        }
      });
      BrandingColors.to(".dark--branding, .light--branding", { top: "30px", opacity: "0", transitionDuration: '0' })

      let MarqueeTop = gsap.timeline({
        scrollTrigger: {
          trigger: ".start",
          scrub: 1,
          start: "-100%",
          end: "300",
          pin: false,
        }
      });
      MarqueeTop.to(".tp", { left: "0" })

      let MarqueeBottom = gsap.timeline({
        scrollTrigger: {
          trigger: ".start",
          scrub: 1,
          start: "-100%",
          end: "300",
          pin: false,
        }
      });
      MarqueeBottom.to(".bt", { right: "0" })

      let MarqueeTopVac = gsap.timeline({
        scrollTrigger: {
          trigger: ".marq--vac",
          scrub: 1,
          start: "-200%",
          end: "300",
          pin: false,
        }
      });
      MarqueeTopVac.to(".tpx", { left: "0" })

      let MarqueeBottomVac = gsap.timeline({
        scrollTrigger: {
          trigger: ".marq--vac",
          scrub: 1,
          start: "-200%",
          end: "300",
          pin: false,
        }
      });
      MarqueeBottomVac.to(".btx", { right: "0" })

      let mtgo = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "100%",
          end: "300",
          pin: false,
        }
      });
      mtgo.to(".mtgo", { backgroundColor: "rgba(0, 31, 63, 1)" })

      let hamburger = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "100",
          end: "300",
          pin: false,
        }
      });
      hamburger.to(".hamburger div", { backgroundColor: "rgba(0, 31, 63, 1)" })

      let search = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "100",
          end: "300",
          pin: false,
        }
      });
      search.to(".searchbtn svg path", { fill: "#001f3f" })

      let searchOpacity = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "200",
          end: "400",
          pin: false,
        }
      });
      searchOpacity.to(".searchbtn", { opacity: "1" })

      let Reviews = gsap.timeline({
        scrollTrigger: {
          trigger: "main",
          scrub: 1,
          start: "bottom bottom",
          duration: "200",
          pin: false,
          // markers: true,
        }
      });
      Reviews.to(".google-reviews-cta", { y: "200" })
    }

  });
}
animations()

// regio's
function regions() {
  jQuery(document).ready(function () {
    jQuery("body").on('click', '.regio--name', function () {
      jQuery(this).next('.branches').slideToggle(200);
      jQuery(this).toggleClass('is--open');
    });
  });
}
regions()

function Faq() {
  function openTabState(tabid, when = 'default', event) {
    if (when == 'default') {
      history.pushState(null, null, location.href.replace(location.hash, "") + '#' + tabid);
    }
    if (when == 'onload') {
      if (location.hash !== '') {
        if (location.hash.includes("faq")) {
          setTimeout(function () {
            jQuery('html,body').animate({ scrollTop: jQuery(location.hash).offset().top - 175 }, 1000);
          }, 100);
          var tabTitleDiv = jQuery('' + location.hash);
          var hashTabOuter = jQuery(tabTitleDiv).closest('.faqs');
          hashTabOuter.find('.is--open').find('.answ').slideUp(200);
          hashTabOuter.find('.is--open').removeClass('is--open');
          tabTitleDiv.addClass('is--open');
          tabTitleDiv.find('.answ').slideDown(200);
        }
      }
    }
  }
  jQuery(document).ready(function ($) {
    jQuery('body').on('click', '.faq', function (e) {
      if (jQuery(this).hasClass('is--open')) {
        jQuery(this).removeClass('is--open');
        jQuery(this).find('.answ').slideUp(200);
        var tabid = jQuery(this).attr('id');
      } else {
        jQuery(this).addClass('is--open');
        jQuery(this).find('.answ').slideDown(200);
        var tabid = jQuery(this).attr('id');
      }

      openTabState(tabid, 'default', e)
    });

    // extra logics for tab
    jQuery('a[href*=\\#]').on('click', function (e) {
      var tabid = jQuery(this).attr('href');
      tabid = tabid.replace('#', '');
      if (tabid.includes("tab")) {
        openTabState(tabid, 'default', e)
        jQuery('#' + tabid).closest('.tabs-horizontal').find('.open').removeClass('open');
        jQuery('#' + tabid).addClass('open');
        var tabnumber = jQuery('#' + tabid).attr('tabnumber');
        jQuery('#' + tabid).closest('.tab-fields').find('.tab-' + tabnumber).addClass('open');
      } else {
        return;
      }
    });

    // onload open hash tab
    openTabState('none', 'onload', 'none')

    // on hash change
    window.onhashchange = function () {
      if (location.hash !== '') {
        if (location.hash.includes("faq")) {
          openTabState(location.hash, 'onload', 'none')
        }
      }
    };
  });
}
Faq()

function NavAnimation() {
  jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 160) {
      jQuery(".main-nav ul li a").addClass("colr--changed");
      jQuery(".main-nav").addClass("colr--changed");
    } else {
      jQuery(".main-nav").removeClass("colr--changed");
      jQuery(".main-nav ul li a").removeClass("colr--changed");
    }
  });
}
NavAnimation()

// Scroll to top button
function ScrollTop() {
  jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 600) {
      jQuery(".btp").addClass("is--visible");
    } else {
      jQuery(".btp").removeClass("is--visible");
    }
  });

  jQuery('.btp').on('click', function (e) {
    e.preventDefault();
    jQuery('html, body').animate({ scrollTop: 0 }, '300');
  });
}
ScrollTop()

function MegaMenu() {
  jQuery("body").on('click', '.mtgo', function () {
    jQuery(this).toggleClass('h--open');
    jQuery('.mgm').toggleClass('clickable');
    jQuery('.l').animate({ 'height': 'toggle' }, 400);
    jQuery('.r').animate({ 'width': 'toggle' }, 400);
    jQuery('.mgm .le').toggleClass('op');
    jQuery('.mgm .ri').toggleClass('op-r');
    jQuery('.news-nav').toggleClass('is--v');
    jQuery('.mgm--nav li').toggleClass('is--shown');
    jQuery('nav').toggleClass('mgm--open');
  });
}
MegaMenu()

function HamburgerMenu() {
  jQuery("body").on('click', '.hamburger', function () {
    jQuery('.mobile-nav-fs').toggleClass('is_visible');
    jQuery('nav').toggleClass('mobile_is_visible');
    jQuery('.hamburger').toggleClass('is__open');
    jQuery('.mobile-nav-fs ul li a').toggleClass('show__me');
  });

  jQuery("body").on('click', '.mobile-nav-fs .menu-item-has-children', function () {
    jQuery(this).find('.sub-menu').slideToggle();
  });
}
HamburgerMenu()


function CustomerSlider() {
  jQuery(document).ready(function () {
    $('.customers-over').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      focusOnSelect: true,
      centerMode: false,
      dots: false,
      lazyLoaded: true,
      prevArrow: jQuery('.nxt-slds-customer'),
      nextArrow: jQuery('.nxt-slds-customer'),
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: jQuery('.nxt-slds-customer'),
          nextArrow: jQuery('.nxt-slds-customer'),
        }
      }]
    });
  });
}
CustomerSlider()

function SmoothScroll() {
  jQuery('a[href*=\\#]').on('click', function (event) {
    target = jQuery(this).attr('href');
    if (target === '#') {
      event.preventDefault();
      return;
    } else if (target.slice(0, 1) === '#') {
      event.preventDefault();
      jQuery('html,body').animate({ scrollTop: jQuery(this.hash).offset().top }, 1000);
    }
  });


  jQuery(".dwn").click(function () {
    var cls = jQuery(this).closest("section").next().offset().top + -100;
    jQuery("html, body").animate({ scrollTop: cls }, "slow");
  });
}
SmoothScroll()

function PopUps() {
  if (jQuery('#lef-popup-holder').length > 0) {
    var popup = jQuery('#lef-popup-holder');
    var popup_id = popup.attr('data-popup-id');
    var popup_behavior = popup.attr('data-popup-behavior');
    var popup_seconds = popup.attr('data-popup-seconds');

    if ('seen' !== Cookies.get('flex_popup_' + popup_id)) {
      if (popup_behavior == 'mouse-leave') {
        jQuery(document).mouseleave(function () {
          if (jQuery(document).scrollTop() > 200) {
            jQuery(popup).css("display", "flex").hide().fadeIn();
            jQuery(popup).find('#lef-popup').fadeIn();
          }
        });
      } else if (popup_behavior == 'seconds') {
        setTimeout(function () {
          jQuery(popup).css("display", "flex").hide().fadeIn();
          jQuery(popup).find('#lef-popup').fadeIn();
        }, (popup_seconds * 1000));
      }

      jQuery('#lef-popup-bg').click(function () {
        jQuery(popup).css("display", "flex").hide().fadeOut();
        jQuery('#lef-popup').fadeOut();
      });

      jQuery('.popup-close').click(function () {
        jQuery(popup).css("display", "flex").hide().fadeOut();
        // jQuery('#lef-popup-bg').fadeOut();
        jQuery('#lef-popup').fadeOut();
      });

      jQuery('#lef-popup-bg, .popup-close').click(function () {
        Cookies.set('flex_popup_' + popup_id, 'seen', { expires: 2, path: '/' });
      });
    }
  }
}
PopUps()

function PopUpForms() {
  if (jQuery('#popup-forms-holder').length > 0) {
    var popup = jQuery('#popup-forms-holder');

    jQuery('#display_popup').click(function(e) {
      e.preventDefault();
      jQuery(popup).css("display", "flex").hide().fadeIn();
    });

    jQuery('#popup-forms-bg').click(function () {
      jQuery(popup).css("display", "flex").hide().fadeOut();
//      jQuery('#popup-forms').fadeOut();
    });

    jQuery('.popup-forms-close').click(function () {
      jQuery(popup).css("display", "flex").hide().fadeOut();
//      jQuery('#popup-forms').fadeOut();
    });

  }
}
PopUpForms()

function search() {
  jQuery('.searchbtn').click(function () {
    jQuery('#searchpopup_bg').fadeIn();
    jQuery('#searchpopup').fadeIn();
  });

  jQuery('.search-close').click(function () {
    jQuery('#searchpopup_bg').fadeOut();
    jQuery('#searchpopup').fadeOut();
  });

  jQuery('#searchpopup_bg').click(function () {
    jQuery('#searchpopup_bg').fadeOut();
    jQuery('#searchpopup').fadeOut();
  });
}
search()

function cookiesPopup() {
  if ('accepted' !== Cookies.get('acceptcookies')) {
    jQuery('.cookies').fadeIn();
    jQuery('.cookies .checked').click(function () {
      jQuery('.cookies').fadeOut();
    });
    jQuery('.cookies .checked').click(function () {
      Cookies.set('acceptcookies', 'accepted', { expires: 2, path: '/' });
    });
  }
}
cookiesPopup()

function simulated() {
  jQuery(document).on('click tap', '[data-href]', function (e) {
    e.preventDefault();
    var href = jQuery(this).find('a:first').attr('href');
    var target = jQuery(this).find('a:first').attr('target') ? jQuery(this).find('a:first').attr('target') : '_self';
    window.open(href, target);
  });

  jQuery(document).on('click tap', '[data-href-simulated-click]', function (e) {
    var exclude = jQuery(this).attr("data-href-simulated-click");
    if (jQuery(e.target).hasClass(exclude) && exclude !== '') {
      return;
    } else {
      e.preventDefault();
      jQuery(this).find('a:first').trigger('simulated-click');
    }
  });

  jQuery("._form_element").each(function (index) {
    if (jQuery(this).children().length < 1) {
      jQuery(this).css('display', 'none');
    }
  });
}
simulated()

function Slick() {
  $(document).ready(function () {
    $('.carrousel-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: true,
      centerMode: true,
      dots: true,
      lazyLoaded: true,
      appendDots: $(".dots"),
    });
  });


  $(document).ready(function () {
    $('.other-items').slick({
      infinite: true,
      slidesToScroll: 1,
      arrows: true,
      focusOnSelect: true,
      centerMode: false,
      dots: false,
      lazyLoaded: true,
      prevArrow: $('.nxt-slds'),
      nextArrow: $('.nxt-re'),
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $(document).ready(function () {
    $('.carrousel-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: true,
      centerMode: true,
      dots: true,
      lazyLoaded: true,
      appendDots: $(".dots"),
    });
  });

  $(document).ready(function () {
    $('.stappen').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      focusOnSelect: true,
      centerMode: false,
      dots: false,
      lazyLoaded: true,
      prevArrow: $('.nxt-slds'),
      nextArrow: $('.nxt-slds'),
      responsive: [
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 820,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}
Slick()

jQuery(document).ready(function () {
  jQuery('.gfield_list_group_item').each(function () {
    let label = jQuery(this).data("label");
    let input = jQuery(this).children();
    input.attr('placeholder', label);
  });
});

jQuery(document).ready(function () {
  jQuery('.add_list_item').each(function () {
    let label = jQuery(this).data("label");
    jQuery(this).html(label);
  });
});
